export default __webpack_public_path__ + "src/assets/icn-questions.efd6ec8dafa567c1cea4de565372d3eb.svg";